import React from 'react'
import { render } from 'react-dom'
import { configureStore, history } from './store/configureStore'
import Root from './containers/Root'
import registerServiceWorker from './registerServiceWorker'
import './styles/index.css';

const store = configureStore()

render(
  <Root store={store} history={history} />,
  document.getElementById('root')
)

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', function() {
      registerServiceWorker();
  });
}
